import { call, put, takeLatest, all } from 'redux-saga/effects';
import types from "./actionTypes";
import Swal from 'sweetalert2';
import { post } from 'helpers/api_helper';

// Common Function Generator
function* commonReportSaga(action, successType, failureType, api) {
  try {
    const response = yield call(post, api, action.payload);
    if (response.status !== "success") throw new Error(response.message);
    yield put({ type: successType, payload: response.data });
  } catch (error) {
    yield put({ type: failureType, payload: error.message });
  }
}

// Watchers
function* watchEmployeeReportSagas() {
  yield takeLatest(types.FETCH_EMPLOYEE_ACTIVITY_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(action, types.FETCH_EMPLOYEE_ACTIVITY_REPORT_SUCCESS, types.FETCH_EMPLOYEE_ACTIVITY_REPORT_FAILURE, process.env.REACT_APP_EMPLOYEE_ACTIVITY_REPORT);
  });

  yield takeLatest(types.FETCH_MY_ACTIVITY_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(action, types.FETCH_MY_ACTIVITY_REPORT_SUCCESS, types.FETCH_MY_ACTIVITY_REPORT_FAILURE, process.env.REACT_APP_MY_ACTIVITY_REPORT);
  });

  yield takeLatest(types.FETCH_AGE_WISE_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(action, types.FETCH_AGE_WISE_REPORT_SUCCESS, types.FETCH_AGE_WISE_REPORT_FAILURE, process.env.REACT_APP_AGE_WISE_REPORT);
  });

  yield takeLatest(types.FETCH_BIRTHDAY_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(action, types.FETCH_BIRTHDAY_REPORT_SUCCESS, types.FETCH_BIRTHDAY_REPORT_FAILURE, process.env.REACT_APP_BIRTHDAY_REPORT);
  });

  yield takeLatest(types.FETCH_EXEMPTION_RESIGNED_REPORT_REQUEST, function* (action) {
    yield* commonReportSaga(action, types.FETCH_EXEMPTION_RESIGNED_REPORT_SUCCESS, types.FETCH_EXEMPTION_RESIGNED_REPORT_FAILURE, process.env.REACT_APP_EXEMPTION_RESIGNED_REPORT);
  });
}

export default function* employeeReportSaga() {
  yield all([watchEmployeeReportSagas()]);
}
